import { render, staticRenderFns } from "./ExamResults.vue?vue&type=template&id=2927e500"
import script from "./ExamResults.vue?vue&type=script&lang=js"
export * from "./ExamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports